import React, { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router'



function Success() {

    useEffect(() => {
        setTimeout(() => {
            window.close();
        }, 2000);
    }, []);

    return (<div className="manage-container">

        <h3>Thank you - We are processing your payment.</h3>

        <p>This page will close automatically.</p>

        <style jsx>{`
            
            .manage-container {
                margin: 0 auto;
                width: 100%;
                text-align: center;
            }

            `}</style>

    </div>);

};

export default Success;

export const Route = createFileRoute('/_authenticated/settings/subscription/success')({ component: Success })
